<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-6"> </p>
<p class="CONTitle ParaOverride-6"><a href="#/V4481_eBook6#_idTextAnchor000">Revenge</a></p>
<p class="CONTitle"><span href="#/V4481_eBook11#_idTextAnchor001" title="Link target outside of Sample">The Man Who Gave Up His Name</span></p>
<p class="CONTitle"><span href="#/V4481_eBook17#_idTextAnchor002" title="Link target outside of Sample">Legends of the Fall</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4481_eBook5.vue?6b4c9c29